import { ref } from 'vue';

export function usePostSaleStatusTransitionFeedback({
  closeTransition,
  transition,
}) {
  const saving = ref(false);
  const showFeedback = ref(false);

  const closeFeedback = () => {
    showFeedback.value = false;
  };

  const submit = async payload => {
    saving.value = true;
    try {
      const result = await transition(payload);
      if (!result) return null;

      closeTransition();
      showFeedback.value = true;
      return result;
    } catch {
      return null;
    } finally {
      saving.value = false;
    }
  };

  return { closeFeedback, saving, showFeedback, submit };
}
